export default function CookiesAlertModule(element) {

    element.querySelector('.cookiealert__cta .btn').addEventListener('click', function (e) {

        gsap.to(element, {
            y: '100%',
            duration: 0.4,
        });

        localStorage.cookieAlertHidden = '1';
        
    });

    if (!localStorage.cookieAlertHidden && !window.isLH) {
        gsap.to(element, {
            y: 0,
            duration: 0.4,
        });
    }

    return this;

}
